/* eslint-disable import/prefer-default-export */
import JSZip from 'jszip';

// 將多個檔案(Binary)壓縮成 ZIP 檔並下載
// fileList 格式：[{ name: 'xxx', file: (binary) }, ... ]
export function downloadBinaryFilesInZip(fileName, fileList, rootFolderName = null) {
    const zip = new JSZip();

    if (rootFolderName) {
        // 將每個檔案加入資料夾
        const folder = zip.folder(rootFolderName);
        fileList.forEach((f) => {
            folder.file(f.name, f.file, { binary: true });
        });
    } else {
        // 將每個檔案加入 ZIP
        fileList.forEach((f) => {
            zip.file(f.name, f.file, { binary: true });
        });
    }

    // 生成 ZIP 並下載
    zip.generateAsync({ type: 'blob' }).then((content) => {
        const url = URL.createObjectURL(content);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${fileName}.zip`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    });
}
